import { render, staticRenderFns } from "./pieChartHospital.vue?vue&type=template&id=d8160de8&scoped=true"
import script from "./pieChartHospital.vue?vue&type=script&lang=js"
export * from "./pieChartHospital.vue?vue&type=script&lang=js"
import style0 from "./pieChartHospital.vue?vue&type=style&index=0&id=d8160de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8160de8",
  null
  
)

export default component.exports